import { ThreePlanogram } from "../store/types";
import { PlanogramShelf } from "@CommonTypes/merchflow/pog/shelf";
import { Shelf } from "./Shelf";

interface Props {
  shelves: PlanogramShelf[];
  showDividers?: boolean;
  three: ThreePlanogram;
}

export const Shelves = ({ shelves, showDividers, three }: Props) => {
  return shelves.map((shelf) => (
    <Shelf key={shelf.uniqueId} shelf={shelf} showDividers={showDividers} three={three} />
  ));
};
